import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTabs from "components/common/tabs/CustomTabs";

import Documents from "components/pages/transmissions/modal/patient/tabs/generalInformation/tabs/documents/Documents";
import PatientTasks from "components/pages/transmissions/modal/patient/tabs/generalInformation/tabs/task/PatientTasks";
import AlertBannerTab from "components/pages/transmissions/modal/patient/tabs/generalInformation/tabs/banner/AlertBannerTab";

import PatientReport from "components/pages/transmissions/modal/patient/tabs/generalInformation/tabs/report/PatientReport";
import PatientAnalytics from "components/pages/transmissions/modal/patient/tabs/generalInformation/tabs/analytics/PatientAnalytics";
import { changePatientTab } from "app/store/transmission/slice/transmissionSlice";

const ProfileTabs = () => {
  const dispatch = useDispatch();
  const { patientTab } = useSelector((state) => state.transmission);

  const PATIENT_PROFILE_TABS = [
    {
      label: "Reports",
      value: "reports",
      component: <PatientReport />,
    },
    {
      label: "Tasks",
      value: "tasks",
      component: <PatientTasks />,
    },
    {
      label: "Alert Banner",
      value: "alertBanner",
      component: <AlertBannerTab />,
    },
    {
      label: "Analytics",
      value: "patientAnalytics",
      component: <PatientAnalytics />,
    },
    {
      label: "Documents",
      value: "documents",
      component: <Documents />,
    },
  ];

  return (
    <CustomTabs
      tabs={PATIENT_PROFILE_TABS}
      selectedTab={patientTab}
      onChange={(newTab) => dispatch(changePatientTab(newTab))}
    />
  );
};

export default ProfileTabs;
